export const STATES = {
  NONE: '',
  UPLOADING: 'uploading',
  COMPLETE: 'complete',
};

export const KINDS = {
  DRAG_TARGET: 'drag-target',
  BUTTON: 'button',
};
